import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";
import useCreate from "hooks/useCreate";

import { Main, Dashboard, InputColorPicker } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

const InputField = (props) => <Input {...props} />;
const InputColorPickerField = (props) => <InputColorPicker {...props} />;

const ShopNew = ({ handleSubmit, change, pristine, history }) => {
  const { is_creating, create } = useCreate({
    path: "/shops",
    onSuccess: ({ id }) => {
      history.push(`/shops/${id}`);
    },
    onError: (err) => {
      throw new SubmissionError(err);
    },
  });

  const onSubmit = (values) => create(values);

  return (
    <Main
      page={{
        name: "Sklepy",
        icon: <ShopIcon />,
        breadcrumbs: [
          {
            name: "Sklepy",
            path: "/shops",
          },
          { name: "Dodaj sklep" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <Dashboard
            footer={
              <>
                <Button type="cancel" onClick={() => history.push("/shops")} />
                <Button
                  type="save"
                  text="Utwórz"
                  disabled={pristine || is_creating}
                  onClick={handleSubmit(onSubmit)}
                />
              </>
            }
          >
            <form
              className="dashboard__form"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <div className="row m-b-10">
                <div className="box-6">
                  <Field
                    name="name"
                    label="Nazwa"
                    component={InputField}
                    type="text"
                  />
                </div>
                <div className="box-6">
                  <Field
                    name="identifier"
                    label="Identyfikator"
                    component={InputField}
                    type="text"
                  />
                </div>
              </div>
              <div className="row m-b-10">
                <div className="box-6">
                  <Field
                    name="label_text"
                    label="Skrócona nazwa"
                    component={InputField}
                    type="text"
                  />
                </div>
                <div className="box-6">
                  <Field
                    name="label_color"
                    label="Kolor"
                    handleChange={(color) => change("label_color", color)}
                    component={InputColorPickerField}
                  />
                </div>
              </div>
            </form>
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors["name"] = "Nazwa jest wymagana!";
  }

  if (!values.label_text) {
    errors["label_text"] = "Skrócona nazwa jest wymagana!";
  }

  if (!values.label_color) {
    errors["label_color"] = "Kolor jest wymagany!";
  }

  if (!values.identifier) {
    errors["identifier"] = "Identyfikator jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "create-shop",
  enableReinitialize: true,
  validate,
})(ShopNew);
